module.exports = __webpack_public_path__ + "static/blossomfloralhamper-b1d31cc20da46aa3eaa15aa6ea7865d3.jpeg";